import customerConfig from "@/customer/config.json"

import { getInjectedUiOption, type UiOptionKey } from "./runtime-branding"

/** The build-time `customer/config.json` key each runtime switch overrides. */
export const BUILD_TIME_UI_OPTION_NAMES: Record<UiOptionKey, string> = {
  show_dev_options: "isDev",
  show_thought_process: "showThoughtProcess",
  segment_demo_data: "segment_demo_data",
}

/**
 * Whether a per-deployment UI switch is on (#3225).
 *
 * Same precedence as the rest of branding: the value an admin stored (injected
 * by the server) wins, then the build-time `customer/config.json`, then off.
 * The build-time value only counts when it is literally `true`, which is how
 * `segment_demo_data` was already read and keeps a stray string from opting a
 * tenant into anything.
 */
export function uiOption(key: UiOptionKey): boolean {
  const injected = getInjectedUiOption(key)
  return injected !== undefined ? injected : buildTimeUiOption(key)
}

/** What this build says for a switch, ignoring any stored override. */
export function buildTimeUiOption(key: UiOptionKey): boolean {
  const config = (customerConfig as { config?: Record<string, unknown> }).config
  return config?.[BUILD_TIME_UI_OPTION_NAMES[key]] === true
}
